/**
 * explorerUrl — S10-11
 *
 * Baut die Helium-Explorer-URL im FE (statt sich auf die vom BE gelieferte
 * `explorer_url` zu verlassen, die den `device_type` nicht kennt):
 *   - IoT-Hotspots        → https://explorer.helium.com/iot/hotspots/<address>
 *   - WiFi/MOBILE-Hotspots → https://explorer.helium.com/mobile/hotspots/<address>
 *   - unbekannter/fehlender device_type → bisheriges Verhalten: BE-`explorer_url`
 *     bevorzugt, sonst Fallback auf den generischen Hotspot-Pfad.
 *
 * Werte-Quelle: DEVICE_TYPE_MAP in deviceType.ts (iot, cbrs, wifi, wifioutdoor,
 * wifiindoor) sowie 'mobile' und die Unterstrich-Varianten 'wifi_indoor' /
 * 'wifi_outdoor', die im Rest des Codes (z.B. quotaError.ts) vorkommen.
 */

const HELIUM_EXPLORER = 'https://explorer.helium.com'

const IOT_TYPES = new Set(['iot'])
// 'wifidataonly': realer BE-Wert (Helium-API mobileInfo.deviceType, siehe
// poc_stats_service.rb NON_POC_DEVICE_TYPES) — gehört ebenfalls zum Mobile-Netz.
const MOBILE_TYPES = new Set(['cbrs', 'wifi', 'wifiindoor', 'wifioutdoor', 'wifidataonly', 'mobile'])

function normalizeDeviceType(deviceType: string | null | undefined): string {
  if (!deviceType) return ''
  return deviceType.toLowerCase().replace(/_/g, '')
}

/**
 * Reine Funktion — leicht unittestbar (kein React/Hook-Kontext noetig).
 *
 * @param address       Blockchain-Pubkey des Hotspots (ohne address kein Link).
 * @param deviceType    Roh-Wert vom Backend (z.B. 'iot', 'wifi', 'wifi_outdoor').
 * @param beExplorerUrl Vom BE mitgelieferte `explorer_url` (Fallback fuer
 *                      unbekannten/fehlenden device_type, z.B. Validatoren).
 */
export function explorerUrlFor(
  address: string | null | undefined,
  deviceType: string | null | undefined,
  beExplorerUrl: string | null | undefined,
): string | null {
  // Kein Link ohne address — gilt unabhaengig von device_type/BE-explorer_url.
  if (!address) return null

  const normalized = normalizeDeviceType(deviceType)

  if (IOT_TYPES.has(normalized)) {
    return `${HELIUM_EXPLORER}/iot/hotspots/${address}`
  }

  if (MOBILE_TYPES.has(normalized)) {
    return `${HELIUM_EXPLORER}/mobile/hotspots/${address}`
  }

  // unbekannter/fehlender device_type → bisheriges Verhalten
  return beExplorerUrl ?? `${HELIUM_EXPLORER}/hotspots/${address}`
}
